import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS, COMPANY } from "../../mock";
import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";

export default function FAQ() {
  return (
    <section id="faq" className="py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <span className="section-eyebrow">FAQs</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">
              Questions, answered.
            </h2>
            <p className="mt-5 text-slate-600">
              Couldn&rsquo;t find what you were looking for? Drop us a line
              and we&rsquo;ll get back within a working day.
            </p>
            <Button
              asChild
              className="mt-6 rounded-full bg-slate-900 hover:bg-slate-800"
            >
              <a href={`mailto:${COMPANY.email}`} className="group">
                Email the team
                <ArrowRight className="ml-1.5 h-4 w-4 btn-arrow" />
              </a>
            </Button>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  value={`item-${i}`}
                  key={i}
                  className="border-slate-200"
                >
                  <AccordionTrigger className="text-left text-base lg:text-lg font-medium text-slate-900 hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed text-[15px] pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
